// Module
var code = "<div id=\"editEmailDialog\" fs-confirm-dialog ok-callback=\"discardChanges()\" ok-button-text=\"Discard\">\r\n    <div>\r\n        <span id=\"email-template-dialog-message\"><strong>WARNING:</strong> You have unsaved changes to the template you are currently viewing.  Do you wish to discard those changes?</span>\r\n    </div>\r\n</div>";
// Exports
module.exports = code;